import { useAtomValue } from 'jotai/utils';

import {
  getSizeRecommendObjectId,
  showBottomZigzinBannerAtom,
  SizeRecommendObjectId,
  useCatalogProductIdParams,
  useGetPdpIntegratedData,
  useTimeoutTooltip,
} from '@domains/pdp-common';

export interface Props {
  sizeRecommendRef: HTMLDivElement | null;
  wrapperRect: {
    top: number;
    height: number;
  };
  isDescriptionOpened: boolean;
}

export const useSizeRecommendTooltipService = ({ sizeRecommendRef, wrapperRect, isDescriptionOpened }: Props) => {
  const param = useCatalogProductIdParams();
  const isShowBottomZigzinBanner = useAtomValue(showBottomZigzinBannerAtom);
  const extraBottom = isShowBottomZigzinBanner ? 40 : 0;
  const { size_recommendation } = useGetPdpIntegratedData(param);

  const { isTooltipShown, setIsTooltipShown } = useTimeoutTooltip({
    key: 'isDescriptionTooltipShown',
    time: 5000,
    dep: [isDescriptionOpened, wrapperRect, size_recommendation],
    isUnrevealed: () =>
      !isDescriptionOpened ||
      !size_recommendation ||
      !!getSessionItemToExceptionHandling(`size_recommend_body_info?${param.catalog_product_id}`) ||
      getSizeRecommendObjectId(size_recommendation.recommendation_type) !== SizeRecommendObjectId.SIMILAR_SIZE,
    isRevealedWithScroll: () => window.scrollY > wrapperRect.top + wrapperRect.height * 0.35,
  });

  const getSessionItemToExceptionHandling = (key: string) => {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  };

  const goToSizeRecommend = () => {
    const container = sizeRecommendRef;
    if (container) {
      container.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      setIsTooltipShown(false);
    }
  };

  return { extraBottom, isTooltipShown, goToSizeRecommend };
};
